import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { ImportWriteType } from '@y42/json-schema';

@UntilDestroy()
@Component({
  selector: 'y42-import-type-renderer',
  templateUrl: './import-type-cell-renderer.component.html',
  styleUrls: ['./import-type-cell-renderer.component.scss'],
})
export class ImportTypeCellRendererComponent extends BaseCellRendererComponent<ImportWriteType> {
  state = connectState(this, {
    importType: this.value$,
  });
}
